import isNumber from 'lodash/isNumber';
import find from 'lodash/find';
import format from 'date-fns/format';
import headers from 'src/config/grosses-table-headers';
import getDay from 'date-fns/get_day';
import addDays from 'date-fns/add_days';

export const formatDate = (value, dateFormat = 'M/D/YYYY') => {
    if (isNumber(value)) {
        return format(value * 1000, dateFormat);
    }

    return format(value, dateFormat);
};

export const isInViewport = $el => {
    const distance = $el.getBoundingClientRect();

    return (
        distance.top >= 0 &&
        distance.left >= 0 &&
        distance.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        distance.right <=
            (window.innerWidth || document.documentElement.clientWidth)
    );
};

export const getNewSortKeyAndDirection = (
    newKey,
    currentKey,
    currentDirection,
) => {
    const header = find(headers, { key: newKey });

    const flipDirection = currentDirection === 'desc' ? 'asc' : 'desc';

    return {
        direction:
            newKey === currentKey ? flipDirection : header.defaultSort || 'asc',
        key: newKey,
    };
};

export const shortenNumber = (value, prefix = '') => {
    if (value === 0) {
        return `${prefix}0`;
    }

    const abbrs = [{ abbr: 'M', minVal: 1000000 }, { abbr: 'K', minVal: 1000 }];

    for (let index in abbrs) {
        const obj = abbrs[index];

        if (value >= obj.minVal) {
            return `${prefix}${value / obj.minVal}${obj.abbr}`;
        }
    }

    return `${prefix}${value}`;
};

export const toSrcSet = srcSet =>
    Object.keys(srcSet)
        .map(key => `${srcSet[key]} ${key}`)
        .join(',');

export const mediaQueryWidth = (size, constraint) => {
    const sizes = {
        small: '350px',
        medium: '750px',
        large: '900px',
        xl: '1280px',
    };

    const width = sizes[size] || size;

    return `(${constraint}-width: ${width})`;
};

export const getNextSunday = date => addDays(date, 7 - (getDay(date) || 7));
